import { KK, SetMagnetSenior } from '@hid/define/define'
import { DeviceConnectMode, DeviceState, FirmwareUpgradeStatus, KeyGroup, KeyZone, MusicCaptureStatus, SpecificItem, SpecificItemAction } from './enum'

export interface CurrentDevice {
  ID: number
  state?: DeviceState // 废弃
  IsSupportMagnet: boolean
  ConnectMode: DeviceConnectMode
  Limit: DeviceLimit
  ProductName?: string // exe返回的设备没有这个字段
  IDStr: string
  IsEEvision: boolean
}

export interface ChangeDevice {
  ID: number
}
export interface WatchDevice {
  Device: number
  In: boolean
  State: DeviceState
}
export interface UsingDeviceData {
  ID: number
  MaxDelay: number
  Name: string
}

export enum DeviceChangeType {
  dpi = 0,
  power = 1,
  status = 2,
}
export interface DeviceChange {
  ChangeData: ChangeData
  ChangeType: DeviceChangeType
  State: ResDeviceState
}
export interface ChangeData {
  DpiIndex: number
}
// export interface ResSetData {
//   LightMode: LightModeParam;
//   LightCustom: { [index: KK]: number };
//   LightLastIsCustom: boolean;
//   Mouse: MouseSetData;
//   ColorsDynamic: ColorsDynamic;
//   Layout: ResLayout;
//   LayoutFn: ResLayout;
// }

// export interface ResLayout {
//   KeyMap: { [index: KK]: VK };
//   KeyMedia: { [index: KK]: VK };
//   KeyMouse: { [index: KK]: VK };
//   MacroType:{ [index: KK]: MacroType} ;
//   Macros: { [index: KK]: MacroParam[] };
//   Magenet: { [index: KK]: SetMagnetSenior };
//   KeyMapModifier: { [index: KK]: VK[] };
// }

export interface MouseSetData {
  DpiColors: [number[]]
  DpiList: number[]
  DpiIndex: number
  Rate: number
}

export interface MacroDetails {
  Key: number
  CycleType: number
  CycleTimes: number
  Records: MacroParam[]
  IsFn: boolean
}

export interface MacroParam {
  Key: number
  Press: boolean
  Delay: number
}

export interface MacroType {
  LoopType: number
  LoopTimes: number
}
export interface PostMagnetSenior {
  Key: number
  Value: SetMagnetSenior
  IsFn: boolean
}

export interface SetMagnetKey {
  KeyCode: number[]
  KeyFunction: number[]
  Travel: number
}

export interface DeviceLimit {
  DpiLen: number
  KeysColorLen: number
  MacroIndexLen: number
  MacroBytesLen: number
  MacroPrefix: number[]
  KeySetLen: number
  MagnetLen: number
}

export interface ResDeviceState {
  ConnectType: DeviceConnectMode //连接方式
  IsSleep: boolean
  IsConnect: boolean
}

// export interface ResSetData {
//     LightMode: LightModeParam;
//     LightCustom: { [index: KK]: number };
//     LightLastIsCustom: boolean;
//     Mouse: MouseSetData;
//     ColorsDynamic: ColorsDynamic;
//     Layout: ResLayout;
//     LayoutFn: ResLayout;
//   }

// export interface ResLayout {
//   KeyMap: { [index: KK]: number };
//   KeyMedia: { [index: KK]: number };
//   KeyMouse: { [index: KK]: number };
//   MacroType:{ [index: KK]: MacroType} ;
//   Macros: { [index: KK]: Record[] };
//   Magenet: { [index: KK]: SetMagnetSenior };
//   KeyMapModifier: { [index: KK]: VK[] };
// }

export interface LightModeParam {
  Mode: number //灯效 LightModeType
  Light: number //亮度
  Speed: number
  FullColor: boolean // 是否全彩
  Color: number
  ColorBG: number
  Direction: number
  Colors?: Palette
  SideMode: number
}

export interface MouseSetData {
  DpiColors: [number[]]
  DpiList: number[]
  DpiIndex: number
  Rate: number
}

export interface SetMagnetKey {
  KeyCode: number[]
  KeyFunction: number[]
  Travel: number
}

export interface DataTravel {
  PressNum: number //第1个条的数值
  ReleaseNum: number //第1个条的数值
  QuickTriggerPressNum: number //第2个条的数值 如果没有填0
  QuickTriggerReleaseNum: number //第3个条的数值 如果没有填0
}

export interface DataDeadZone {
  Top: number
  Bottom: number
}

export interface PostSetLed {
  Mode: number
  Light: number
  Speed: number
  FullColor: boolean
  Color: number
  ColorBG: number
  Direction: number
  Colors?: Palette // 仅针对晶泰V2版本
  SideMode: number // 废弃 侧光模式
}

export interface DataProfileForDecorate {
  LightLastIsCustom: boolean
  LightMode: PostSetLed
  ColorsCustom: Map<KK, number>
  ColorsDynamic: PostDynamicColor
}

export interface MouseProfile {
  DpiColors: number[][]
  DpiIndex: number // 表示当前 DPI 索引
  DpiList: number[] // 表示 DPI 列表，最大长度为7
  Rate: number // 表示鼠标报告率
}

export interface PostKeysColor {
  Keys: PostKeyColor[]
  Light: number // 灯光亮度
}

export interface PostKeyColor {
  Key: number
  Value: number
}

export interface postMagnetKeyInfo extends MagnetKeyInfo {
  Key: KK
  KeyType: number
}

export interface MagnetKeyInfo {
  PressNum: number
  ReleaseNum: number
  QuickTriggerPressNum: number
  QuickTriggerReleaseNum: number
}

export interface PostMagnetSetKeyInfo extends MagnetKeyInfo {
  Keys: KK[]
}

export interface PostMagnetSetKeyDeadZone extends DataDeadZone {
  Keys: KK[]
}

export interface PostSpecificItem {
  Item: SpecificItem
  Action: SpecificItemAction
  Value: any | null
}

export interface KeyZoneData {
  Zone: KeyZone[]
  Order: number
}

export interface KeysGroup {
  Name: KeyGroup
  Keys: KK[]
}

export interface PostMusicData {
  Mode: number
  FullColor: boolean
  Color: number
  State: MusicCaptureStatus
}

export interface Palette {
  Data: [number, number, number, number, number, number, number]
  Index: number
}

export interface PostDynamicColor {
  Mode: number
  FullColor: boolean
  Color: number
  Run: boolean
  IsEEvision: boolean
}

export interface FirmwareUpdateMessage {
  Current: number
  Total: number
  Status: FirmwareUpgradeStatus
}
